/**
 * Única puerta de entrada a las variables de entorno.
 *
 * Nada fuera de este archivo lee `import.meta.env`: así la configuración queda
 * tipada, validada al arranque y es trivial de sustituir en tests.
 */
interface AppConfig {
  readonly apiUrl: string;
  readonly appName: string;
  readonly isProduction: boolean;
}

function required(value: string | undefined, name: string): string {
  if (value === undefined || value.trim().length === 0) {
    throw new Error(`Falta la variable de entorno ${name}.`);
  }
  return value.trim();
}

export const appConfig: AppConfig = {
  apiUrl: required(
    import.meta.env.VITE_API_URL ?? 'https://api.cocina.pecepe.pe/api/v1',
    'VITE_API_URL',
  ),
  appName: 'Inventario Cocina',
  isProduction: import.meta.env.PROD,
};
